import { WSButton, WSButtons, WSText } from "@wingspanhq/fe-component-library";
import { MemberWorkFlowStatus } from "@wingspanhq/payments/dist/interfaces";
import { InvoiceRow, PayeeReviewStatus } from "@wingspanhq/wingspan-api-sdk";
import { WSQueryCache } from "@ws-react-query";
import React, { useState } from "react";
import { queriesInvoiceRows, queriesInvoices } from "@query";
import { addNotification } from "../../../../components/Notification/Notification";
import { paymentsService } from "../../../../services/payments";
import { bulkActionFactory } from "../../../../modules/BulkActions";

type Props = {
  data: InvoiceRow[];
  onFinish?(): void;
  onClose: () => void;
};

export const ModalBulkAccept: React.FC<Props> = ({
  data,
  onFinish,
  onClose
}) => {
  const [isUpdating, setIsUpdating] = useState(false);

  let paidItems: string[] = [];

  const bulkAccept = bulkActionFactory({
    onStart: () => {
      setIsUpdating(true);
      paidItems = [];
    },
    action: async (item: InvoiceRow) => {
      const invoiceId = item.id;

      if (!invoiceId || item.payeeReviewStatus === PayeeReviewStatus.ACCEPTED) {
        return;
      }

      return await paymentsService.invoice.update(invoiceId, {
        member: {
          workflowStatus: MemberWorkFlowStatus.Accepted
        }
      });
    },
    onFinish: ({ successItems, failedItems }) => {
      WSQueryCache.invalidateQueries(
        queriesInvoiceRows.searchInvoiceRows.queryKeyBase
      );
      WSQueryCache.invalidateQueries(queriesInvoices.getInvoice.queryKeyBase);

      addNotification({
        timeout: 6000,
        text:
          `${successItems.length} invoice${
            successItems.length > 1 ? "s" : ""
          } have been accepted` +
          (paidItems.length > 0
            ? `, ${paidItems.length} ${
                paidItems.length > 1 ? "were" : "was"
              } already paid`
            : "") +
          (failedItems.length > 0 ? `, ${failedItems.length} failed` : "")
      });

      setIsUpdating(false);
    }
  });

  return (
    <>
      <WSText.Heading5 mb="M">
        Accept {data.length} invoice{data.length > 1 && "s"}?
      </WSText.Heading5>
      <WSText mb="XL">
        Accept selected invoice{data.length > 1 && "s"} to be paid
      </WSText>

      <WSButtons format="modal">
        <WSButton
          loading={isUpdating}
          onClick={async () => {
            await bulkAccept.run(data);
            onFinish?.();
            onClose();
          }}
        >
          Accept
        </WSButton>
        <WSButton.Tertiary disabled={isUpdating} onClick={onClose}>
          Cancel
        </WSButton.Tertiary>
      </WSButtons>
    </>
  );
};
